<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" />
    <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" stroke-width="2" />
    <circle cx="12" cy="8" r="1" fill="currentColor" />
  </svg>
</template>
